import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "product-box__segment-header" }
const _hoisted_2 = {
  key: 0,
  class: "product-box__vintage"
}
const _hoisted_3 = { class: "product-box__name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "product-box__short-description"
}
const _hoisted_6 = {
  key: 2,
  class: "product-box__short-description"
}
const _hoisted_7 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productLink ? 'a' : 'div'), {
      class: "product-box__header-text",
      href: _ctx.productLink
    }, {
      default: _withCtx(() => [
        (_ctx.productBoxData.vintage)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.productBoxData.vintage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("span", _hoisted_3, [
          (_ctx.numberOfBottlesInSet)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.numberOfBottlesInSet) + " x\n        ", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" " + _toDisplayString(_ctx.productBoxData.description1), 1 /* TEXT */)
        ]),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (_ctx.productBoxData.description2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.productBoxData.description2), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _cache[3] || (_cache[3] = _createTextVNode()),
        (_ctx.productBoxData.shortDescription)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.productBoxData.shortDescription), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href"])),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createElementVNode("button", {
      class: _normalizeClass(["product-box__button-wishlist", {
        'product-box__button-wishlist--filled': _ctx.isWishlistEnabled && _ctx.productBoxData.inWishlist,
        'product-box__button-wishlist--remove': !_ctx.isWishlistEnabled,
        'product-box__button-wishlist--loading': _ctx.state === 'loadingWishlist',
      }]),
      "aria-label": _ctx.$t('wishlist.default.name'),
      type: "button",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('wishlistClicked')), ["prevent"]))
    }, null, 10 /* CLASS, PROPS */, _hoisted_7)
  ]))
}